<template>
  <button
    class="button-outlined-component"
    :style="`
      border-color: ${button_color};
      min-width: ${width || 100}px;
      min-height: ${height || 50}px;
      padding: ${padding || 0};
    `"
    :disabled="is_disabled"
    v-ripple
    @click="$emit('buttonClicked')"
  >
    <template v-if="!loading">
      <slot name="icon"/>
      <TIcon
        v-if="icon"
        class="button-outlined-component-icon"
        :name="icon"
        :color="button_color"
      />
    </template>

    <v-progress-circular
      v-else
      class="mr-1"
      size="24"
      width="3"
      :color="color"
      indeterminate
    />

    <slot name="text"/>
    <TText
      v-if="text || value"
      :value="value"
      :text="text"
      :color="button_color"
      :size="text_size || 12"
      :font_weight="400"
    />
  </button>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    components: {
      TText,
      TIcon,
    },

    props: [
      'icon', // is string, contains leading icon font string. please use this OR the icon slot
      'text', // is string, contains following text for button. please use this OR the text slot
      'value', // is string, contains following text for button. Translatable
      'text_size', // is number, contains text size in pt
      'width', // is number, width of button in px
      'height', // is number, height of button in px
      'padding', // is number, controls padding of button
      'color', // is hexcolor, contains color of text and border
      'is_disabled', // is boolean, controlls wether the button in disabled or not
      'loading',
    ],

    mixins: [
      TColor,
    ],

    data: () => ({

    }),

    computed: {
      button_color() {
        let c = this.getColor(this.color);
        if(this.is_disabled)
          return this.getTranspHexColor(c, 0.5);
        else
          return c;
      },
    },

    methods: {

    },
  }
</script>

<style>
  .button-outlined-component {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-gap: 4px;
    border: 1px solid;
    border-radius: 4px;
    transition: border-color 0.5s;
  }
  .button-outlined-component-icon {
    transition: none;
  }
</style>
